/* eslint-disable jsdoc/check-param-names */
import { Dispatch, SetStateAction } from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";

type Props = {
  id: string;
  label: string;
  value: string;
  onChange: (val: any) => void;
  options: string[] | readonly string[];
  required?: boolean;
  textRequired?: boolean;
  disabled?: boolean;
  isContainBlank?: boolean;
};

/**
 * カスタムテキストフィールド
 * @param id フィールドID
 * @param label ラベル
 * @param value 値
 * @param onChange 値が選択される
 * @param required 必須かどうか
 * @param textRequired 必須テキスト
 * @param disabled 非活性
 * @param isContainBlank 選択肢に空白を含むかどうか
 * @returns JSX.Element
 */
export default function LabeledSelect({
  id,
  label,
  value,
  onChange,
  options,
  required,
  textRequired,
  disabled,
  isContainBlank = true,
}: Props) {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      position="relative"
      height={50}
      width={0}
      margin="0 auto"
    >
      <Box textAlign="right" marginRight={1} position="absolute" right={10} width="max-content">
        {label}
        {textRequired && (
          <Typography component="span" color="red">
            （必須）
          </Typography>
        )}：
      </Box>
      <Box position="absolute" width="max-content" minWidth={223} left={5}>
        <FormControl sx={{ minWidth: 160, width: "100%", maxWidth: 207 }} required={required}>
          <InputLabel
            id={`${id}-label`}
            sx={{
              top: "-6px",
              "&.MuiInputLabel-shrink": {
                transform: "translate(14px, -4px) scale(0.75)",
              },
              "& .MuiFormLabel-asterisk": {
                color: "var(--red-800)",
              },
              color: disabled ? "#aaa" : {}, // 文字
            }}
          >
            {label}
          </InputLabel>
          <Select
            labelId={`${id}-label`}
            label={label}
            id={id}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            sx={{
              height: "40px",
              "&& .Mui-disabled": disabled ? {
                color: "#eaeaea",
              } : {},
              "&& .MuiOutlinedInput-notchedOutline": disabled ? {
                borderColor: "#eaeaea", // 囲み
              } : {},
            }}
            disabled={disabled}
          >
            {isContainBlank && (
              // eslint-disable-next-line no-irregular-whitespace, react/self-closing-comp
              <MenuItem key="" value="">
                &emsp;
              </MenuItem>
            )}
            {options.map((s) => (
              <MenuItem key={s} value={s}>
                {s}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Stack>
  );
}
